export default function params() {
    return {
        unlistedNotices() {
            return {
                isListed: {
                    group: {
                        conjunction: 'OR',
                    },
                },
                isListedFalse: {
                    condition: {
                        path: 'non_public',
                        operator: '=',
                        memberOf: 'isListed',
                        value: false,
                    },
                },
                isListedNull: {
                    condition: {
                        path: 'non_public',
                        operator: 'IS NULL',
                        memberOf: 'isListed',
                    },
                },
            };
        },
        publicationFilter(fieldName) {
            // Date arrondie (à la baisse) à la minute : l'URL reste identique pendant
            // une minute, comme la durée de cache des pages d'avis (Drupal / Varnish),
            // ce qui permet au cache de servir la réponse au lieu de la recalculer.
            const roundedDate = new Date();
            roundedDate.setSeconds(0, 0);
            // Heure UTC sans fuseau, au format des champs date de Drupal
            // (Y-m-d\TH:i:s) : JSON:API compare les valeurs comme du texte et
            // ignorerait un décalage (-04:00).
            const nowISO = roundedDate.toISOString().slice(0, 19);
            return {
                status: {
                    condition: {
                        path: 'status',
                        operator: '=',
                        value: '1',
                    },
                },
                publicationStart: {
                    condition: {
                        path: `${fieldName}_start`,
                        operator: '<=',
                        value: nowISO,
                    },
                },
                publicationEndGroup: {
                    group: {
                        conjunction: 'OR',
                    },
                },
                publicationEnd: {
                    condition: {
                        path: `${fieldName}_end`,
                        operator: '>',
                        value: nowISO,
                        memberOf: 'publicationEndGroup',
                    },
                },
                publicationEndEmpty: {
                    condition: {
                        path: `${fieldName}_end`,
                        operator: 'IS NULL',
                        memberOf: 'publicationEndGroup',
                    },
                },
            };
        },
        // Uniquement les champs lus par le module horaires
        // (NoticeItem et l'index des avis du store `schedules`)
        noticesV2Fields() {
            return {
                notices_v2: 'title,subtitle,general,path,parcours',
                'paragraph--avis_parcours': 'routes',
                taxonomyTermsRoutes: 'name,code_direction',
            };
        },
        // Avis de parcours et avis généraux, séparés par le store `schedules`.
        // Pas de filtre sur les parcours : en groupe OR avec `general`, JSON:API
        // exclurait les avis généraux sans parcours. Seul un avis général peut
        // être enregistré sans parcours.
        noticesV2() {
            return {
                filter: {
                    ...this.unlistedNotices(),
                    ...this.publicationFilter('date_notice'),
                },
                fields: {
                    ...this.noticesV2Fields(),
                },
                page: {
                    limit: 500,
                },
                include: 'parcours,parcours.routes',
            };
        },
    };
}
